import gql from "graphql-tag";

const UPDATE_WORKORDERS_IN_SAP = gql`
  mutation ($id: Int, $affiliate: String) {
    updateWorkOrderInSap(id: $id, affiliate: $affiliate)
  }
`;

export { UPDATE_WORKORDERS_IN_SAP };
